import { Component, OnInit } from '@angular/core';

import { ErrorStrings, UserTitles, ValidationPatterns } from 'src/app/constants/form.constants';
import { User } from 'src/app/interfaces/user';
import { UserService } from 'src/app/services/user/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Alert } from 'src/app/interfaces/alert';
import { NgForm } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { RedirectionParams, RedirectionService } from 'src/app/services/redirection/redirection.service';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-update-title',
  templateUrl: './update-title.component.html',
  styleUrls: ['./update-title.component.scss']
})
export class UpdateTitleComponent implements OnInit {
  errorStrings = ErrorStrings;
  loading = false;
  alert: Alert = null;
  user: User;
  redirectParams?: RedirectionParams;
  public UserTitles = UserTitles;
  newTitle: string;
  existingTitle: string;
  useRebrandedLayout: boolean;

  validationPatterns = ValidationPatterns;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private redirectionService: RedirectionService,
    private featureFlagService: FeatureFlagsService
  ) {
    this.user = this.route.snapshot.data.user as User;
    this.useRebrandedLayout = this.featureFlagService.isEnabled('useRebrandedLayout');
  }

  save(form: NgForm) {
    this.closeAlert();
    this.loading = true;

    this.userService.saveTitle(this.newTitle)
      .subscribe(
        updatedUser => {
          this.user = updatedUser;
          this.existingTitle = this.getExistingTitle();
          form.controls.title.reset();
          this.newTitle = '';

          this.alert = {
            type: 'success',
            message: 'Your personal information has been updated.'
          };

          if (this.redirectParams) {
            this.router.navigate(this.redirectParams.l, { queryParams: this.redirectParams.q, fragment: this.redirectParams.f });
          }
        },
        err => {
          if (err instanceof HttpErrorResponse && err.status === 400) {
            this.alert = {
              type: 'danger',
              message: 'There was a problem updating your title.'
            };
          } else {
            this.alert = {
              type: 'danger',
              message: 'An error has occurred. Please try again later.'
            };
          }
        }
      )
      .add(() => {
        this.loading = false;
      });
  }

  closeAlert() {
    this.alert = null;
  }

  getExistingTitle(): string {
    return this.user.title;
  }

  ngOnInit(): void {
    this.existingTitle = this.getExistingTitle();

    // Setting redirection to be used when title is saved or when pressing back
    this.redirectParams = this.redirectionService.getParams(this.route.snapshot.queryParams.r);
  }
}
